/* ==========================================================================
   Fine Art by Renee — appearance switch wiring.

   The state machine itself lives in the small blocking script at the top of
   layout/theme.liquid, because it has to run before the first paint or the
   page flashes white on its way to dark. That script leaves window.ReneeTheme
   behind. This file is only the DOM half: keep the radio buttons showing the
   truth, and write the visitor's choice down when they change it.

   Deferred on purpose. If it never loads, the colours are still right — the
   inline script has already applied them — and the switch simply sits on
   whatever position the server rendered.
   ========================================================================== */

(function () {
  'use strict';

  var api = window.ReneeTheme;
  if (!api) return;

  function eachSwitch(fn) {
    var nodes = document.querySelectorAll('[data-renee-theme-switch]');
    for (var i = 0; i < nodes.length; i++) fn(nodes[i]);
  }

  /* There are two instances of the switch on a page — header and menu drawer —
     and they are separate radio groups, so moving one has to move the other. */
  function sync(pref) {
    eachSwitch(function (el) {
      var input = el.querySelector('[data-renee-theme-value="' + pref + '"]');
      if (input && !input.checked) input.checked = true;
    });
  }

  function onChange(event) {
    var target = event.target;
    if (!target || !target.getAttribute) return;
    var pref = target.getAttribute('data-renee-theme-value');
    if (!pref || !api.valid[pref]) return;
    api.set(pref);
    sync(pref);
  }

  function init() {
    sync(api.pref);
    /* Delegated, so a drawer re-rendered by the theme editor still works. */
    document.addEventListener('change', onChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  /* The visitor changed it in another tab. */
  window.addEventListener('storage', function (event) {
    if (event.key !== api.key) return;
    var pref = api.valid[event.newValue] ? event.newValue : 'system';
    api.set(pref, false);
    sync(pref);
  });

  /* Shopify's theme editor swaps section markup out from under us. */
  document.addEventListener('shopify:section:load', function () {
    sync(api.pref);
  });
})();
